"use client";

export type TastingPanelListFilterKeywords = {
  productType?: string[];
  businessStatus?: string[];
  businessCategoryName?: string[];
  categoryManager?: string[];
  developer?: string[];
  vendor?: string[];
};

export type TastingPanelListSortOrder = "ASC" | "DESC";

export interface TastingPanelListRequest {
  pageNo: number;
  pageSize: number;
  search: string;
  sortBy?: string;
  sortOrder?: TastingPanelListSortOrder;
  filterKeywords: TastingPanelListFilterKeywords;
}

export interface TastingPanelVendorStatus {
  id?: number | string;
  vendorName?: string;
  vendorAssessmentStatus?: string;
  businessStatus?: string;
  ingredientStatus?: string;
  subStatus?: string | null;
  published?: boolean | null;
  previousState?: string;
  vendorAssessmentId?: string;
}

export interface TastingPanelListItem {
  id: number | string;
  title?: string;
  name?: string;
  productType?: string;
  businessCategoryName?: string;
  category?: string;
  addedOn?: string;
  cancellationDate?: string | null;
  developer?: string;
  businessStatus?: string;
  subStatus?: string | null;
  sellingPeriod?: string;
  estWeeklySales?: string | number | null;
  estWeeklyUnitVol?: string | number | null;
  /** Idea-level product size for list columns. */
  size?: string | number | null;
  /** Idea-level case pack for list columns. */
  packSize?: string | number | null;
  /** Idea-level retail price, shown as Proposed Retail. */
  retailPrice?: string | number | null;
  reasonForDevelopment?: string;
  productSpecificationType?: string;
  categoryManager?: string;
  categoryManagerUser?: { id?: number | string; userName?: string };
  vendorList?: unknown;
  vendorStatus?: TastingPanelVendorStatus[];
  vendorStatuses?: string[];
  vendorCorporateName?: string[];
  vendorDetails?: Array<{ id?: number | string; vendorName?: string }>;
  [key: string]: unknown;
}

export interface TastingPanelListResponse {
  items: TastingPanelListItem[];
  totalCount?: number;
  pageNo?: number;
  pageSize?: number;
}

export const EMPTY_TASTING_PANEL_LIST_FILTER_KEYWORDS: TastingPanelListFilterKeywords = {};

export function tastingPanelListHasAppliedQuery(
  filters: TastingPanelListFilterKeywords | null | undefined,
  search: string | null | undefined
): boolean {
  if ((search ?? "").trim().length > 0) return true;
  const f = filters ?? EMPTY_TASTING_PANEL_LIST_FILTER_KEYWORDS;
  return (
    (f.productType?.length ?? 0) > 0 ||
    (f.businessStatus?.length ?? 0) > 0 ||
    (f.businessCategoryName?.length ?? 0) > 0 ||
    (f.categoryManager?.length ?? 0) > 0 ||
    (f.developer?.length ?? 0) > 0 ||
    (f.vendor?.length ?? 0) > 0
  );
}
